<template>
  <div class="leader-board">
    <Loading v-if="loading"></Loading>
    <div class="m-container">
      <!-- breadcrumbs -->
      <div class="bread-crumbs-holder">
        <q-breadcrumbs active-color="Black" separator=">">
          <q-breadcrumbs-el label="Event" to="/event"/>
          <q-breadcrumbs-el label="WRO Events" :to="{name:'Event-Details',params:{id: this.$route.params.id}}"/>
          <q-breadcrumbs-el label="LeaderBoard"/>
        </q-breadcrumbs>
      </div>
      <!-- breadcrumbs -->

      <!-- Table -->
      <div class="the-table">
        <div class="event-details-header">
          <div class="tabs-wrapper">
            <p class="text">LeaderBoard</p>
            <q-tabs
                v-model="tab"
                dense
                class="text-grey"
                active-color="primary"
                indicator-color="primary"
                align="justify"
                narrow-indicator>
              <q-tab name="1" label="Round 1"></q-tab>
              <q-tab name="2" label="Round 2"></q-tab>
              <q-tab name="3" label="Round 3"></q-tab>
            </q-tabs>
          </div>
        </div>

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="1">
            <!-- table -->
            <q-markup-table>
              <thead>
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Name</th>
                <th class="text-left">Team</th>
                <th class="text-left">Total Score</th>
                <th class="text-left">Total Time</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="table.length > 0">
                <tr v-for="(infos, index) in table" :key="infos.id">
                  <td class="text-left">{{ index + 1 }}</td>
                  <td class="text-left">{{ infos.event_name }}</td>
                  <td class="text-left">{{ infos.team_name }}</td>
                  <td class="text-left">{{ infos.score }}</td>
                  <td class="text-left">{{ infos.time }}</td>
                </tr>
              </template>
              <tr v-else>
                <td class="text-center" colspan="5">There is no data to show</td>
              </tr>
              </tbody>
            </q-markup-table>
          </q-tab-panel>

          <q-tab-panel name="2">
            <!-- table -->
            <q-markup-table>
              <thead>
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Name</th>
                <th class="text-left">Team</th>
                <th class="text-left">Total Score</th>
                <th class="text-left">Total Time</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="table.length > 0">
                <tr v-for="(infos, index) in table.slice(0, 25)" :key="infos.id">
                  <td class="text-left">{{ index + 1 }}</td>
                  <td class="text-left">{{ infos.event_name }}</td>
                  <td class="text-left">{{ infos.team_name }}</td>
                  <td class="text-left">{{ infos.score }}</td>
                  <td class="text-left">{{ infos.time }}</td>
                </tr>
              </template>
              <tr v-else>
                <td class="text-center" colspan="6">There is no data to show</td>
              </tr>
              </tbody>
            </q-markup-table>
          </q-tab-panel>

          <q-tab-panel name="3">
            <!-- table -->
            <q-markup-table>
              <thead>
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Name</th>
                <th class="text-left">Team</th>
                <th class="text-left">Total Score</th>
                <th class="text-left">Total Time</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="table.length > 0">
                <tr v-for="(infos, index) in table.slice(0, 9)" :key="infos.id">
                  <td class="text-left">{{ index + 1 }}</td>
                  <td class="text-left">{{ infos.event_name }}</td>
                  <td class="text-left">{{ infos.team_name }}</td>
                  <td class="text-left">{{ infos.score }}</td>
                  <td class="text-left">{{ infos.time }}</td>
                </tr>
              </template>
              <tr v-else>
                <td class="text-center" colspan="6">There is no data to show</td>
              </tr>
              </tbody>
            </q-markup-table>
          </q-tab-panel>
        </q-tab-panels>

      </div>
    </div>

    <sponsors></sponsors>
    <contact-us></contact-us>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";
import ContactUs from "@/components/home/ContactUs";
import Sponsors from "@/components/home/Sponsors";

export default {
  name: 'Leaderboard',
  data() {
    return {
      competitions: [],
      loading: false,
      table: [],
      tab: '1'
    }
  },
  components: {Sponsors, Loading, ContactUs},
  mounted() {
    this.$API.general.leaderboard({event_id: this.$route.params.id, round: 1})
        .then(response => {
          this.table = response
        })
  },
  watch: {
    'tab'() {
      this.$API.general.leaderboard({event_id: this.$route.params.id, round: this.tab})
          .then(response => {
            this.table = response
          })
    }
  },
}
</script>

<style scoped>

.text {
  font-size: 40px;
  font-weight: 500;
  color: #0A0443;
}

.the-table {
  margin-top: 45px;
}

.the-table > p {

}

.the-table .table-header {
  position: relative;
}

.the-table .table-header span {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  color: var(--mainColors);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.the-table .q-markup-table {
  box-shadow: none !important;
}

.the-table td {
  /*box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16)!important;*/
  border-right: 5px solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: 5px solid rgba(0, 0, 0, 0.12) !important;
}

.the-table .tbody {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

thead {
  color: #7C7C7C;
  font-size: 13px;
  font-weight: 600;
}

tr {
  height: 73px !important;
  font-weight: 600 !important;
}

td img {
  width: 44px !important;
  height: 44px !important;
  object-fit: cover;
}

.the-table td:last-of-type {
  border-right: 0px solid rgba(0, 0, 0, 0.12) !important;
}


@media (max-width: 761px) {
  .wro-categories .wro-categories-textContent .content p:nth-child(1) {
    font-size: inherit;
    width: inherit;
  }

  .wro-categories .wro-categories-p span {
    display: none;
  }
}

@media (max-width: 1120px) {
  .content .select-categories {
    /*height: initial;*/
  }

  .content .select-categories-item {
    padding: 30px 0 0px 26px !important;
  }

  .wro-categories .wro-categories-textContent .content p:nth-child(2) {
    padding-right: 20px;
  }

  .wro-categories .wro-categories-textContent .content {
    padding: 57px 10px 0px;
  }

}

@media (max-width: 599px) {
  .wro-categories .wro-categories-textContent {
    height: initial;
  }

  .content .select-categories {
    height: initial;
  }

  .wro-categories .wro-categories-p span {
    width: 45px;
  }
}

.item-img img {
  width: 88px !important;
}
</style>
